import WithdrawalInstructionsOptionRendererComponent from './WithdrawalInstructionSelectOption';

export default WithdrawalInstructionsOptionRendererComponent;